import { ButtonType } from 'libs/components/src/lib/utils/button';

export const addProjectPackageButtonConfig = {
  text: 'PROJECT_MODULE.PROJECT_PACKAGE_CREATE_COMPONENT.ADD_PACKAGE_TO_PROJECT',
  type: ButtonType.Primary
};
